// extracted by mini-css-extract-plugin
module.exports = {"modal":"LoadingDialog_modal__2aPlX","logoContainer":"LoadingDialog_logoContainer__3jbor","logo":"LoadingDialog_logo__r7bYD","text":"LoadingDialog_text__DMrVf"};